import React from 'react'
import GiftContext from '../../../context/context'
import Field from '../../common/field'

export default class FormSMS extends React.Component {
  static contextType = GiftContext

  state = {
    resend: 30,
  }

  resendTimerId = null

  componentDidMount() {
    this.resendTimer()
  }

  componentWillUnmount() {
    clearInterval(this.resendTimerId)
  }

  resendTimer = () => {
    this.setState({ resend: 30 })
    this.resendTimerId = setInterval(() => {
      this.setState({ resend: this.state.resend - 1 })
      if (this.state.resend < 1) {
        clearInterval(this.resendTimerId)
      }
    }, 1000)
  }

  resendSMS = () => {
    this.resendTimer()
    this.props.sendSMS(true)
  }

  handleChange = (_, value) => this.context.handleChangeField('userSmsCode', value)

  render() {
    return (
      <GiftContext.Consumer>
        {({ formContent, renderError }) => (
          <div className="form-state --sms">
            <div className="form-field field-sms">
              <p className="field-sms-description">{formContent.texts.smsCodeDescription}</p>
              <Field
                label={formContent.texts.smsCode}
                name="smscode"
                type="text"
                clean="false"
                value={this.context.formData.userSmsCode}
                hasError={renderError('smscode.nonmatch')}
                onChange={this.handleChange}
              />
              <p className="field-sms-resend">
                {formContent.texts.noSmsCode}
                <button
                  type="button"
                  className={this.state.resend && 'non-active'}
                  onClick={this.resendSMS}
                >
                  {formContent.texts.sendAgain} {this.state.resend ? ` (${this.state.resend}s)` : ''}
                </button>
              </p>
            </div>
          </div>
        )}
      </GiftContext.Consumer>
    )
  }
}
